import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=296981d6&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('296981d6')) {
      api.createRecord('296981d6', component.options)
    } else {
      api.reload('296981d6', component.options)
    }
    module.hot.accept("./_id.vue?vue&type=template&id=296981d6&", function () {
      api.rerender('296981d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/transports/views/_id.vue"
export default component.exports